/*------------------------------*
 | @author  Cameron Slupeiks    |
 | @date    2022.12.21          |
 | Copyright Brash Inc. (2020)  |
 *------------------------------*/

// React DayPicker styles
import "@daypicker/react/style.css";
import "./app.scss";

import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router";
import AuthGate from "./components/authentication/auth-gate";
import Authentication from "./components/authentication/authentication";
import { AssetImageURLCacheProvider } from "./components/main/asset-image-url-cache-provider";
import Content from "./components/main/content";
import { DeviceModelProvider } from "./components/main/device-model-provider";
import { MappedinIntegrationProvider } from "./components/main/mappedin-integration-provider";
import StreamProvider from "./components/main/stream-provider";
import { RefreshContextProvider } from "./elements/refresh-context";
import { VelavuModalProvider } from "./elements/velavu-modal";
import { VelavuToastProvider } from "./elements/velavu-toast";
import { TooltipPortalProvider } from "./elements/tooltip-portal";
import SignInContextProvider, {
	useSignInContext,
} from "./components/sign-in-context/sign-in-context";
import { EventEmitterProvider } from "./emitter/emitter-context";

export default function App() {
	return (
		<TooltipPortalProvider>
			<SignInContextProvider>
				<EventEmitterProvider>
					<AppContent />
				</EventEmitterProvider>
			</SignInContextProvider>
		</TooltipPortalProvider>
	);
}

function AppContent() {
	const { isLoading, isSignedIn } = useSignInContext();

	//Don't render anything until the user is loaded
	if (isLoading) {
		return;
	}

	return (
		<Router>
			<Routes>
				<Route
					path="login/*"
					element={
						<AuthGate
							isSignedIn={isSignedIn}
							type="unauthenticated"
						>
							<Authentication />
						</AuthGate>
					}
				/>
				<Route
					path="/*"
					element={
						<AuthGate isSignedIn={isSignedIn} type="authenticated">
							<StreamProvider>
								<DeviceModelProvider>
									<RefreshContextProvider>
										<MappedinIntegrationProvider>
											<AssetImageURLCacheProvider>
												<VelavuToastProvider
													zIndex={100}
												>
													<VelavuModalProvider
														zIndex={100}
													>
														<Content />
													</VelavuModalProvider>
												</VelavuToastProvider>
											</AssetImageURLCacheProvider>
										</MappedinIntegrationProvider>
									</RefreshContextProvider>
								</DeviceModelProvider>
							</StreamProvider>
						</AuthGate>
					}
				/>
			</Routes>
		</Router>
	);
}
